import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import PurchaseOrderDetailPanel from 'modules/procurement/components/purchaseOrders/PurchaseOrderDetailPanel'

const PurchaseOrderDetailPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { id } = useParams()

  if (!id) {
    navigate(navigation.procurement.purchaseOrders.fullPath())
    return null
  }

  const onClose = () => {
    navigate(navigation.procurement.purchaseOrders.fullPath())
  }

  return <PurchaseOrderDetailPanel id={String(id)} onClose={onClose} />
}

export default PurchaseOrderDetailPage
